import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DirectMsg } from '@models/Core/DirectMsg';
import { User } from '@models/Core/User';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { DirectMsgService } from '@services/users/direct-msg.service';
import { linkify } from '@utils/linkify';

@Component({
  selector: 'app-direct-msg',
  templateUrl: './direct-msg.component.html',
  styleUrls: ['./direct-msg.component.scss'],
})
export class DirectMsgComponent implements OnInit, OnDestroy {
  @ViewChild('messagePane') messagePane: ElementRef;

  public messages: DirectMsg[] = [];
  public user: User;
  newMsg: string;
  sending = false;

  constructor(
    private activeModal: NgbActiveModal,
    private service: DirectMsgService,
    private bus: BusService,
    private events: EventsService,
  ) {}

  ngOnInit() {
    this.update();
    this.bus.subscribe(
      this.events.notified.directMsg.received,
      this.checkUpdate,
      this,
    );
  }

  ngOnDestroy() {
    this.bus.unsubscribe(
      this.events.notified.directMsg.received,
      this.checkUpdate,
    );
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  update() {
    this.service.get(this.user).subscribe(messages => {
      this.messages = messages;
      setTimeout(() => {
        this.messagePane.nativeElement.scrollTo({
          top: this.messagePane.nativeElement.scrollHeight,
          behavior: 'smooth',
        });
      }, 5);
    });
  }

  checkUpdate(notif) {
    if (notif.meta.user._id.toString() === this.user._id.toString()) {
      this.update();
      this.bus.publish(
        this.events.requested.action.user.notifications.read,
        notif,
      );
    }
  }

  send() {
    this.sending = true;
    this.service
      .post({
        text: this.newMsg,
        recipient: this.user,
      })
      .subscribe(() => {
        this.newMsg = '';
        this.sending = false;
        this.update();
      });
  }

  lines(msg: DirectMsg) {
    return msg.text
      .trim()
      .split('\n')
      .map(line => linkify(line.trim()));
  }

  showDate(index: number) {
    if (index < this.messages.length - 1) {
      const msg = this.messages[index];
      const next = this.messages[index + 1];
      const diff = (next.created_at as any) - (msg.created_at as any);
      if (msg.created_by === next.created_by && diff < 10 * 60 * 1000) {
        return false;
      }
    }

    return true;
  }
}
